import { render, staticRenderFns } from "./exercise_paper.vue?vue&type=template&id=62e3f98b&scoped=true"
import script from "./exercise_paper.vue?vue&type=script&lang=js"
export * from "./exercise_paper.vue?vue&type=script&lang=js"
import style0 from "./exercise_paper.vue?vue&type=style&index=0&id=62e3f98b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e3f98b",
  null
  
)

export default component.exports